export default "__VITE_ASSET__ExPOURVJ__"